import type { CancellationFieldMeta } from '../services/cancellationRules';
import type { AdjustmentDerivation } from '../utils/deriveAdjustmentTypes';

interface Props {
    metas: CancellationFieldMeta[];
    derivation: AdjustmentDerivation;
}

const codeFor = (meta: CancellationFieldMeta, derivation: AdjustmentDerivation): string | undefined => {
    if (derivation.kind !== 'resolved') return undefined;
    return meta.key === 'positive_balance_adjustment_type' ? derivation.positive : derivation.negative;
};

/** Read-only display for the two derived adjustment types. Props in, nothing out. */
export function DerivedAdjustmentTypes({ metas, derivation }: Props) {
    if (derivation.kind === 'hidden') return null;

    return (
        <div className="space-y-2">
            <dl className="space-y-2">
                {metas.map((meta) => (
                    <div key={meta.key} className="grid grid-cols-[1fr_auto] items-center gap-4">
                        <dt className="mb-1.5 block text-sm font-medium text-mp-foreground">
                            {meta.label}
                        </dt>
                        <dd className="text-sm font-medium">{codeFor(meta, derivation) ?? '—'}</dd>
                    </div>
                ))}
            </dl>
            {derivation.kind === 'indeterminate' && (
                <p className="text-xs text-mp-muted">Dealer type unavailable.</p>
            )}
        </div>
    );
}
